<template>
	<div
		class="loading-bar"
		role="progressbar"
		:aria-valuenow="percentage"
		aria-valuemin="0"
		aria-valuemax="100"
	>
		<div class="loading-bar__track">
			<div
				class="loading-bar__progress"
				:style="{ width: `${percentage}%` }"
			></div>
		</div>
		<span class="loading-bar__label">{{ percentage }}%</span>
	</div>
</template>

<script>
export default {
	name: 'LoadingBar',

	props: {
		processed: {
			type: Number,
			default: 0,
		},
		total: {
			type: Number,
			default: 0,
		},
	},

	computed: {
		percentage() {
			if (this.total <= 0) return 0;

			return Math.min(100, Math.max(0, Math.round((this.processed / this.total) * 100)));
		},
	},
};
</script>

<style scoped>
.loading-bar {
	align-items: center;
	display: flex;
	gap: 0.5rem;
	width: 100%;
}

.loading-bar__track {
	background: #e5e7eb;
	border-radius: 999px;
	height: 0.5rem;
	overflow: hidden;
	width: 100%;
}

.loading-bar__progress {
	background: #3b82f6;
	border-radius: inherit;
	height: 100%;
	transition: width 0.25s ease;
}

.loading-bar__label {
	color: #374151;
	font-size: 0.875rem;
	min-width: 3rem;
	text-align: right;
}
</style>
